import {CONSTANTS} from '@/constants'
import miniToastr from 'mini-toastr'

export const functions_order = {
    data: function () {
        return {
            order: null,
        }
    },
    methods: {
        isName: function (order) {
            if (!order || order===null) return false;
            return  (order.name_ && order.name_!==null)||
                    (order.surname && order.surname!==null)||
                    (order.patro && order.patro!==null);
        },
        isNameCorrect: function (order) {
            if (!order || order===null) return false;
            return  (order.name_correct && order.name_correct!==null)||
                (order.surname_correct && order.surname_correct!==null)||
                (order.patro_correct && order.patro_correct!==null);
        },
        namesDiffer: function (order) {
            if (!this.isName(order)) { return false; }
            return  (order.name_correct !== order.name_)||
                    (order.surname_correct !== order.surname)||
                    (order.patro_correct !== order.patro);
        },
        canCancelOrder: function(order) {
            return (order.status_index == CONSTANTS.ORDER_STATUS_TAKEN) || (order.status_index == CONSTANTS.ORDER_STATUS_POSTPONED);
        },
        canPostponeOrder: function(order) {
            return (order.status_index == CONSTANTS.ORDER_STATUS_ARCHIVED) || (order.status_index == CONSTANTS.ORDER_STATUS_TAKEN);
        },
        canRevertOrder: function(order) {
            return (order.status_index == CONSTANTS.ORDER_STATUS_ARCHIVED) || (order.status_index == CONSTANTS.ORDER_STATUS_POSTPONED);
        },
        canChuserOrder: function(order) {
            return (order.status_index == CONSTANTS.ORDER_STATUS_TAKEN);
        },
        canCreateVoucherFromOrder: function(order) {
            return (order.status_index == CONSTANTS.ORDER_STATUS_TAKEN);
        },
        getOrderStatusTitle: function(order) {
            return CONSTANTS.ORDER_STATUS_NAMES[order.status_index];
        },

        createOrder: function(pub=false, tel=null, rediect_to_edit=true, onSuccess=null, param=null) {
            let f = {tel:tel, pub:pub};
            this.httpPrepare();
            this.$http.post(this.apiurl('order/create'), f).then(function (response) {
                response = this.httpSuccess(response, true, 'Заявка создана');
                this.setLatestOrder(response.payload);
                if (rediect_to_edit) {
                    this.$router.push({path:this.orderPage(response.payload)});
                }
                else {
                    this.executeFunction(onSuccess, param, response.payload);
                }
            }, this.httpError);
        },

        loadOrder: function (order_id, onSuccess=null, param=null) {
            //console.log('loadOrder '+order_id   )
            if (!this.isOrderLoaded() && order_id) {
                this.httpPrepare();
                this.$http.get(this.apiurl('order/' + order_id)).then(function (response) {
                    response = this.httpSuccess(response);
                    this.order = response.payload;
                    this.executeFunction(onSuccess, param, response.payload);
                }, this.httpError)
            }
            return this;
        },

        resetOrder: function () {
            this.order = null;
            return this;
        },

        isOrderLoaded: function () {
            return (this.order !== null) && this.order && this.order.id;
        },

        canAccessOrder: function (order) {
            if (!this.is(order)) return false;
            if (this.is_manager_or_buh || this.is_agency || this.is_admin) return true;
            return order.user_id === this.my_id;
        },

        takeOrderOld: function (onSuccess=null, param=null) {
            this.httpPrepare();
            this.$http.post(this.apiurl('order/take')).then(function (response) {
                response = this.httpSuccess(response, true);
                if (!response) return;
                let order = response.payload.order;
                let count_taken = response.payload.count_taken;
                let extra_text = '';
                if (count_taken > 1) {
                    extra_text += ' Кроме того принято еще ' + (count_taken-1) + ' заявок с такими же контактными данными';
                }
                miniToastr["success"]('', 'Заявка '+order.id+' принята в работу' +extra_text, CONSTANTS.TOAST_SUCCESS_LIFETIME);
                this.setLatestOrder(this.order.id);
                this.executeFunction(onSuccess, param, response.payload);
            }, this.httpError);
        },

        latestOrderClass: function (order) {
            return this.isLatest('App\\Models\\Order', order.id) ? 'latest' : '';
        },
        setLatestOrder: function (id) {
            this.setLatest('App\\Models\\Order', id);
        },

        saveOrder(onSuccess=null, param=null) {
            this.httpPrepare();
            this.$http.post(this.apiurl('order/' + this.order.id + '/save'), {order:this.order,telenums:this.telenums}).then(function (response) {
                response = this.httpSuccess(response, true, 'Заявка сохранена');
                if (!response) return;
                this.setLatestOrder(this.order.id);
                this.executeFunction(onSuccess, param, response.payload);
            }, this.httpError);
        },

        revertOrder(onSuccess=null, param=null) {
            this.httpPrepare();
            this.$http.post(this.apiurl('order/' + this.order_id + '/revert')).then(function (response) {
                response = this.httpSuccess(response, true, 'Заявка восстановлена');
                if (!response) return;
                this.order = response.payload;
                this.setLatestOrder(this.order.id);
                this.executeFunction(onSuccess, param, response.payload);
            }, this.httpError);
        },

        waitOrder(waitDate, waitComment, onSuccess=null, param=null) {
            this.httpPrepare();
            this.$http.post(this.apiurl('order/' + this.order_id + '/wait'), {date:waitDate,comment:waitComment}).then(function (response) {
                response = this.httpSuccess(response, true, 'Заявка отправлена в ожидание');
                if (!response) return;
                this.setLatestOrder(this.order.id);
                this.executeFunction(onSuccess, param, response.payload);
            }, this.httpError);
        },

        cancelOrder(cancelReason, cancelComment, onSuccess=null, param=null){
            this.httpPrepare();
            this.$http.post(this.apiurl('order/' + this.order.id + '/archive'), {reason:cancelReason,comment:cancelComment}).then(function (response) {
                response = this.httpSuccess(response, true, 'Заявка отменена');
                if (!response) return;
                this.setLatestOrder(this.order.id);
                this.executeFunction(onSuccess, param, response.payload);
            }, this.httpError);
        },

        chuserOrder(chuserUser, chuserComment, onSuccess=null, param=null){
            this.httpPrepare();
            this.$http.post(this.apiurl('order/' + this.order_id + '/chuser'), {user:chuserUser,comment:chuserComment}).then(function (response) {
                response = this.httpSuccess(response, true, 'Заявка передана');
                if (!response) return;
                this.setLatestOrder(this.order.id);
                this.executeFunction(onSuccess, param, response.payload);
            }, this.httpError);
        },

        crvOrder(chuserUser, chuserComment, onSuccess=null, param=null){
            this.httpPrepare();
            this.$http.post(this.apiurl('order/' + this.order_id + '/crv'), {order:this.order,telenums:this.telenums}).then(function (response) {
                response = this.httpSuccess(response, true, 'Путевка создана');
                if (!response) return;
                this.setLatestOrder(this.order.id);
                this.executeFunction(onSuccess, param, response.payload);
            }, this.httpError);
        },

    },
    computed: {

    }
};
